import {isArray} from 'lodash';
import React, {FC, useState} from 'react';

import {PushChannelMessage} from '../../../../../libs/shared/core/src/services/push/common/pushMessage';
import {usePushV2Events} from '../../../../../libs/shared/ui/src/push/usePushEvents';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getUser} from '../../../../store/data/teammates/teammatesSelectors';
import {FailedDraftBanner} from '../../failedDraftBanner';

export const DesktopFailedDraftBanner: FC = () => {
  const [failedDraftDescription, setFailedDraftDescription] = useState<string>();
  const user = useAppSelector(getUser);

  const handleMessageEvent = (event: PushChannelMessage) => {
    const {data} = event;
    const rawAuthorIds = data?.author_ids;
    const authorIds = isArray(rawAuthorIds) ? rawAuthorIds : [];
    return () => {
      if (data.error_type && data.error_desc && authorIds.includes(user.id)) {
        setFailedDraftDescription(data.error_desc);
      }
    };
  };

  usePushV2Events([
    {name: 'message_updated', handler: handleMessageEvent},
    {name: 'message_send_draft_failed', handler: handleMessageEvent},
  ]);

  if (!failedDraftDescription) {
    return null;
  }

  return (
    <FailedDraftBanner
      description={failedDraftDescription}
      onDismissClick={() => {
        setFailedDraftDescription(undefined);
      }}
    />
  );
};
